export default "__VITE_ASSET__880770a3__"